export default __webpack_public_path__ + "static/media/expo.14bf45f8.jpg";